import React, { useState } from "react";
import DaumPostcodeEmbed from "react-daum-postcode";
import { useDispatch, useSelector } from "react-redux";

import { Button, Col, Form, Input, Modal, Row, Select } from "antd";
import { Option } from "antd/es/mentions";
import moment from "moment";

import salesManageApi from "../../../apis/SalesManage.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import status from "../../../utils/status";

const OrderDetailComponent = ({
  orderDetail,
  handleOrderDetailModalCancel,
  getUserOrderList,
}) => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [returnAccount, setReturnAccount] = useState(false);
  const [refundHolder, setRefundHolder] = useState(orderDetail?.name);
  const [editStatus, setEditStatus] = useState(false);
  const [deliveryInfo, setDeliveryInfo] = useState({});
  const [isPostalCodeModalOpen, setIsPostalCodeModalOpen] = useState(false);

  const bankList = [
    {
      id: 1,
      name: "국민",
    },
    {
      id: 2,
      name: "신한",
    },
    {
      id: 3,
      name: "농협",
    },
  ];

  const handleEditClick = () => {
    setDeliveryInfo({
      name: orderDetail.name,
      phone: orderDetail.phone,
      postal_code: orderDetail.postal_code,
      address: orderDetail.address,
      address_detail: orderDetail.address_detail,
      address_request: orderDetail.address_request,
    });
    setEditStatus(true);
  };

  const handleEditCancelClick = () => {
    if (
      orderDetail.name !== deliveryInfo.name ||
      orderDetail.phone !==
        (deliveryInfo.phone.includes("-")
          ? deliveryInfo.phone.replaceAll("-", "")
          : deliveryInfo.phone) ||
      orderDetail.address !== deliveryInfo.address ||
      orderDetail.address_detail !== deliveryInfo.address_detail ||
      orderDetail.address_request !== deliveryInfo.address_request
    ) {
      if (
        window.confirm(
          "지금까지 수정했던 내용들이 저장되지 않습니다. 그래도 취소하시겠습니까?",
        )
      ) {
        setEditStatus(false);
        setDeliveryInfo({});
      }
    } else {
      setEditStatus(false);
      setDeliveryInfo({});
    }
  };

  const handleEditCompleteClick = async () => {
    if (window.confirm("작성하신 내용으로 변경하시겠습니까?")) {
      setIsLoading(true);
      try {
        const param = {
          id: orderDetail.order_id,
          name: deliveryInfo.name,
          phone: deliveryInfo.phone.includes("-")
            ? deliveryInfo.phone.replaceAll("-", "")
            : deliveryInfo.phone,
          postal_code: deliveryInfo.postal_code,
          address: deliveryInfo.address,
          address_detail: deliveryInfo.address_detail,
          address_request: deliveryInfo.address_request,
          created_by: orderDetail.created_by,
          updated_by: user.id === 724 ? 1 : user.id,
        };
        const res = await salesManageApi.manualOrderDeliveryInfoEdit(param);
        if (res.code === 200) {
          alert("해당 수정 사항이 정상적으로 반영되었습니다.");
          handleOrderDetailModalCancel();
          getUserOrderList();
        } else {
          throw res.msg;
        }
      } catch (e) {
        console.log(e);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDeliveryInfo({ ...deliveryInfo, [name]: value });
  };

  /**
   * Post Code 입력하기 (다음 주소 api)
   */
  const handlePostCode = (data) => {
    let fullAddress = data.address;
    let extraAddress = "";

    if (data.addressType === "R") {
      if (data.bname !== "") {
        extraAddress += data.bname;
      }
      if (data.buildingName !== "") {
        extraAddress +=
          extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
    }

    if (fullAddress?.length > 0) {
      setDeliveryInfo({
        ...deliveryInfo,
        postal_code: data.zonecode,
        address: fullAddress,
      });
    }
    setIsPostalCodeModalOpen(false); // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
  };

  const disabledEditCompleteBtn = () => {
    if (
      orderDetail.name === deliveryInfo.name &&
      orderDetail.phone ===
        (deliveryInfo.phone.includes("-")
          ? deliveryInfo.phone.replaceAll("-", "")
          : deliveryInfo.phone) &&
      orderDetail.address === deliveryInfo.address &&
      orderDetail.address_detail === deliveryInfo.address_detail &&
      orderDetail.address_request === deliveryInfo.address_request
    ) {
      return true;
    } else if (
      !deliveryInfo.name ||
      !deliveryInfo.phone ||
      !deliveryInfo.address
    ) {
      return true;
    } else if (isLoading) {
      return true;
    } else {
      return false;
    }
  };

  /**
   * 송장번호에 따른 배송안내 popup
   * @param detail
   */
  const deliveryPopup = (e, type, detail) => {
    e.preventDefault();
    e.stopPropagation();
    let popUrl = "";
    if (type === "return") {
      popUrl = `https://${
        detail.return_goodsflow_service_id
          ? `www.goodsflow.io/tracking/tXYtiyVnAX/${detail.return_goodsflow_service_id}`
          : `tracker.delivery/#/${detail.return_delivery_company}/${detail.return_tracking_number}`
      }`;
    } else {
      popUrl = `https://${
        detail.goodsflow_service_id
          ? `www.goodsflow.io/tracking/tXYtiyVnAX/${detail.goodsflow_service_id}`
          : `tracker.delivery/#/${detail.delivery_company}/${detail.tracking_number}`
      }`;
    }
    let popOption =
      "top=10, left=10, width=500, height=700, scrollbars=yes, resizable=no";
    window.open(popUrl, "배송조회", popOption);
  };

  /**
   * 유입경로
   * @param detail
   * @returns {string}
   */
  const funnels = (detail) => {
    let path = "";
    if (detail?.query) {
      if (detail?.is_cooperate) {
        path = "공동구매";
      } else {
        if (detail?.is_manual) {
          path = "전화주문-";
        }
        if (
          detail?.influencer_role === "super_admin" ||
          detail?.influencer_role === "level_1"
        ) {
          path += "인플루언서";
        } else {
          path += "셀러";
        }
      }
    } else if (detail?.is_manual) {
      path = "전화주문";
    } else {
      path = "검색";
    }
    return path;
  };

  return (
    <>
      <>
        {returnAccount && (
          <Modal
            title="환불 계좌 받기"
            visible={returnAccount}
            onCancel={() => setReturnAccount(false)}
            // onOk={handleDepositCancelModalOk}
            cancelText={<span>닫기</span>}
            okText={<span>주문 취소</span>}
            // confirmLoading={isLoading}
            width={"50%"}
          >
            <Form.Item
              label="은행"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Select
                placeholder="선택"
                // value={editCancelReason.cancel_reason}
                // onChange={(value) => setEditCancelReason({...editCancelReason, cancel_reason: value})}
                style={{ width: 250, textAlign: "left" }}
              >
                {bankList.map((item, idx) => (
                  <Option key={`환불계좌_${idx}`} value={item.id}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="계좌 번호"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Input
                className="order-modal-address-request-wrap"
                name="cancel_reason_detail"
                // value={editCancelReason.cancel_reason_detail}
                // onChange={(e) => setEditCancelReason({
                //     ...editCancelReason,
                //     [e.target.name]: e.target.value
                // })}
                rows={5}
              />
            </Form.Item>
            <Form.Item
              label="예금주"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Input
                className="order-modal-address-request-wrap"
                name="cancel_reason_detail"
                value={refundHolder}
                onChange={(e) => {
                  setRefundHolder(e.target.value);
                }}
                // onChange={(e) => setEditCancelReason({
                //     ...editCancelReason,
                //     [e.target.name]: e.target.value
                // })}
                rows={5}
              />
            </Form.Item>
          </Modal>
        )}
      </>
      <div
        className="order-detail-modal-subtitle"
        style={{
          marginTop: 0,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        주문 상세정보
        {(orderDetail.pay_method === "vbank" ||
          orderDetail.pay_method === "deposit") && (
          <Button
            onClick={() => setReturnAccount(true)}
            style={{
              display: "none",
            }}
          >
            환불 계좌
          </Button>
        )}
      </div>
      <Form.Item
        className="order-detail-border-box"
        label="상품주문번호"
        labelAlign="left"
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
      >
        <div className="order-id-wrap">{orderDetail.order_id}</div>
      </Form.Item>
      <Form.Item
        className="order-detail-form-border-box"
        label="상품명"
        labelAlign="left"
        colon={false}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
      >
        {`[${orderDetail.product_brand_name}] ${orderDetail.product_name}`}
      </Form.Item>
      <Row align="middle" wrap={false}>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="상품주문상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ borderRight: 0 }}
          >
            {orderDetail.hasOwnProperty("is_deposit") &&
            orderDetail.is_deposit &&
            orderDetail.order_detail_status === "ready"
              ? "무통장 입금대기"
              : status.orderStatusChange(orderDetail.order_detail_status)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="클레임"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          ></Form.Item>
        </Col>
      </Row>
      <Row align="middle" wrap={false}>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="구매자명"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ borderRight: 0 }}
          >
            {orderDetail.created_by_name}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="유입경로"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          >
            {funnels(orderDetail) +
              (orderDetail?.influencer_name
                ? `-${orderDetail?.influencer_name}`
                : "")}
            {/*{orderDetail.query*/}
            {/*	? orderDetail.is_cooperate*/}
            {/*		? "공동구매"*/}
            {/*		: orderDetail?.is_manual*/}
            {/*		? "전화주문-인플루언서"*/}
            {/*		: "인플루언서"*/}
            {/*	: orderDetail?.is_manual*/}
            {/*	? "전화주문"*/}
            {/*	: "검색"}*/}
          </Form.Item>
        </Col>
      </Row>
      <Row align="stretch" wrap={false}>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="옵션"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ borderRight: 0 }}
          >
            {orderDetail.option_title ? orderDetail.option_title : ""}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="주문수량"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ height: "100%" }}
          >
            {orderDetail.quantity}
          </Form.Item>
        </Col>
      </Row>
      <Row align="stretch" wrap={false}>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="쿠폰 번호"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ borderRight: 0, height: "100%" }}
          >
            {orderDetail.coupon_id === "ADMIN"
              ? "[전화주문] 관리자 할인 적용"
              : orderDetail.coupon_id || ""}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="쿠폰명"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          >
            {orderDetail.coupon_title ? orderDetail.coupon_title : ""}
          </Form.Item>
        </Col>
      </Row>
      <Row align="middle" wrap={false}>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="사용 포인트"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ borderRight: 0 }}
          >
            {orderDetail.use_point
              ? orderDetail.use_point.toLocaleString()
              : ""}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="상품별 할인액"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          >
            {orderDetail.coupon_discount_price && orderDetail.use_point
              ? (
                  orderDetail.coupon_discount_price + orderDetail.use_point
                ).toLocaleString() + "원"
              : orderDetail.use_point
              ? orderDetail.use_point.toLocaleString() + "원"
              : orderDetail.coupon_discount_price
              ? orderDetail.coupon_discount_price.toLocaleString() + "원"
              : ""}
          </Form.Item>
        </Col>
      </Row>
      <Row align="stretch" wrap={false}>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="결제 방식"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ borderRight: 0, height: "100%" }}
          >
            {orderDetail.pay_method
              ? status.matchingPayMethod[orderDetail.pay_method]
              : ""}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="가상 계좌 번호"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          >
            {orderDetail.pay_method && orderDetail.pay_method === "vbank"
              ? orderDetail.vbank_name + " " + orderDetail.vbank_num
              : ""}
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
        className="order-detail-form-border-box"
        label="총 상품금액"
        labelAlign="left"
        colon={false}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
        style={{ borderBottom: "solid 1px #ced4da" }}
      >
        {orderDetail.total_price.toLocaleString() + "원"}
      </Form.Item>
      {orderDetail.hasOwnProperty("is_deposit") && orderDetail.is_deposit && (
        <>
          <div className="order-detail-modal-subtitle">무통장 주문 정보</div>
          <Form.Item
            className="order-detail-form-border-box"
            label="입금자명"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
          >
            {orderDetail.deposit_name}
          </Form.Item>
          <Row align="stretch" wrap={false}>
            <Col span={12}>
              <Form.Item
                className="order-detail-form-border-box order-detail-label-overflow"
                label="현금영수증 신청 여부"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ borderRight: 0 }}
              >
                {orderDetail.cash_receipt_type !== null ? "Y" : "N"}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                className="order-detail-form-border-box order-detail-label-overflow"
                label="현금영수증 발급 여부"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
              >
                {orderDetail.cash_receipt_issue !== null ? "Y" : "N"}
              </Form.Item>
            </Col>
          </Row>
          <Row align="stretch" wrap={false}>
            <Col span={12}>
              <Form.Item
                className="order-detail-form-border-box order-detail-label-overflow"
                label="현금영수증 종류"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ borderRight: 0, borderBottom: "solid 1px #ced4da" }}
              >
                {orderDetail.cash_receipt_type !== null
                  ? orderDetail.cash_receipt_type === 0
                    ? "소득 공제용"
                    : "지출 증빙용"
                  : ""}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                className="order-detail-form-border-box order-detail-label-overflow"
                label="현금영수증 발급 번호"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ borderBottom: "solid 1px #ced4da" }}
              >
                {orderDetail.cash_receipt_phone
                  ? orderDetail.cash_receipt_phone
                  : ""}
              </Form.Item>
            </Col>
          </Row>
        </>
      )}
      <div className="order-detail-modal-subtitle">배송 정보</div>
      <Row align="middle" wrap={false}>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="택배사"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ borderRight: 0 }}
          >
            {orderDetail.delivery_company
              ? status.matchingDeliveryCompany[orderDetail.delivery_company]
              : ""}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="송장번호"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          >
            {orderDetail.tracking_number ? (
              <a
                onClick={(e) => deliveryPopup(e, "delivery", orderDetail)}
                href={`#`}
              >
                {orderDetail.tracking_number}
              </a>
            ) : (
              ""
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row align="middle" wrap={false}>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="발송처리일"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ borderRight: 0, borderBottom: "solid 1px #ced4da" }}
          >
            {orderDetail.ship_date
              ? moment(orderDetail.ship_date).format("YYYY.MM.DD HH:mm:ss")
              : ""}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="배송완료일"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ borderBottom: "solid 1px #ced4da" }}
          >
            {orderDetail.ship_complete_date
              ? moment(orderDetail.ship_complete_date).format(
                  "YYYY.MM.DD HH:mm:ss",
                )
              : ""}
          </Form.Item>
        </Col>
      </Row>
      <Row
        className="order-detail-modal-subtitle"
        justify="space-between"
        align="middle"
        wrap={false}
      >
        배송지 정보
        {orderDetail.is_manual &&
          (orderDetail.order_detail_status === "ready" ||
            orderDetail.order_detail_status === "paid") && (
            <>
              {editStatus ? (
                <Row align="middle" wrap={false} style={{ gap: "5px" }}>
                  <button
                    className="order-detail-edit-delivery-info-btn cancel"
                    onClick={handleEditCancelClick}
                  >
                    취소
                  </button>
                  <button
                    className="order-detail-edit-delivery-info-btn complete"
                    onClick={handleEditCompleteClick}
                    disabled={disabledEditCompleteBtn()}
                  >
                    수정완료
                  </button>
                </Row>
              ) : (
                <button
                  className="order-detail-edit-delivery-info-btn edit"
                  onClick={handleEditClick}
                >
                  정보수정
                </button>
              )}
            </>
          )}
      </Row>
      <Row align="middle" wrap={false}>
        <Col span={12}>
          <Form.Item
            className={
              "order-detail-form-border-box" + (editStatus ? " editText" : "")
            }
            label="수취인명"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ borderRight: 0 }}
          >
            {editStatus ? (
              <Input
                name="name"
                value={deliveryInfo.name}
                onChange={handleChange}
              />
            ) : (
              orderDetail.name
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            className={
              "order-detail-form-border-box" + (editStatus ? " editText" : "")
            }
            label="연락처"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          >
            {editStatus ? (
              <Input
                name="phone"
                value={deliveryInfo.phone}
                onChange={handleChange}
              />
            ) : orderDetail?.phone?.includes("-") ? (
              orderDetail.phone
            ) : orderDetail.phone ? (
              orderDetail.phone?.substr(0, 3) +
              "-" +
              orderDetail.phone?.substr(3, 4) +
              "-" +
              orderDetail.phone?.substr(7, 4)
            ) : (
              "-"
            )}
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
        className={
          "order-detail-form-border-box" + (editStatus ? " editText" : "")
        }
        label="배송지"
        labelAlign="left"
        colon={false}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
      >
        <div className="order-detail-address-info">
          {editStatus ? (
            <>
              <Row align="middle">
                <Input
                  name="postal_code"
                  value={deliveryInfo.postal_code}
                  // onChange={handleChange}
                  onClick={() => setIsPostalCodeModalOpen(true)}
                  style={{ width: "100px" }}
                />
                <button
                  className="order-detail-edit-delivery-info-btn edit"
                  onClick={() => setIsPostalCodeModalOpen(true)}
                >
                  우편번호 검색
                </button>
              </Row>
              <Input
                name="address"
                value={deliveryInfo.address}
                onClick={() => setIsPostalCodeModalOpen(true)}
                // onChange={handleChange}
              />
              <Input
                name="address_detail"
                value={deliveryInfo.address_detail}
                onChange={handleChange}
              />
            </>
          ) : orderDetail.address ? (
            orderDetail.address +
            (orderDetail.address_detail
              ? "\n" + orderDetail.address_detail
              : "")
          ) : (
            "-"
          )}
        </div>
      </Form.Item>
      <Form.Item
        className={
          "order-detail-form-border-box" + (editStatus ? " editText" : "")
        }
        label="배송메모"
        labelAlign="left"
        colon={false}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
        style={{ borderBottom: "solid 1px #ced4da" }}
      >
        <div className="order-detail-address-info">
          {editStatus ? (
            <Input
              name="address_request"
              value={deliveryInfo.address_request}
              onChange={handleChange}
            />
          ) : orderDetail.address_request ===
            "배송 시 요청사항을 선택해주세요." ? (
            ""
          ) : (
            orderDetail.address_request
          )}
        </div>
      </Form.Item>
      {/*반품 관련 내용*/}
      {orderDetail &&
        orderDetail.order_detail_status &&
        (orderDetail.order_detail_status.includes("return") ||
          orderDetail.return_refusal_date) && (
          <>
            <div className="order-detail-modal-subtitle">반품 정보</div>
            <Row align="middle" wrap={false}>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="처리상태"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ borderRight: 0 }}
                >
                  {orderDetail.return_refusal_date
                    ? "반품거부/철회"
                    : status.orderStatusChange(orderDetail.order_detail_status)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="환불상태"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  {orderDetail.payment_status &&
                  orderDetail.payment_status === "cancelled"
                    ? orderDetail.cancel_amount?.toLocaleString() +
                      "원 환불처리완료"
                    : ""}
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              className="order-detail-form-border-box"
              label="반품사유"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              {orderDetail.cancel_reason}
            </Form.Item>
            <Form.Item
              className="order-detail-form-border-box"
              label="반품상세사유"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              <div className="order-detail-address-info">
                {orderDetail.cancel_reason_detail}
              </div>
            </Form.Item>
            <Row align="middle" wrap={false}>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="반품요청일"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ borderRight: 0 }}
                >
                  {orderDetail.cancel_request_date
                    ? moment(orderDetail.cancel_request_date).format(
                        "YYYY.MM.DD HH:mm:ss",
                      )
                    : ""}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="반품 요청자"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  {orderDetail.cancel_target &&
                  orderDetail.cancel_target === "admin"
                    ? "판매자"
                    : "구매자"}
                </Form.Item>
              </Col>
            </Row>
            <Row align="middle" wrap={false}>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="반품승인일"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ borderRight: 0 }}
                >
                  {orderDetail.cancel_approval_date
                    ? moment(orderDetail.cancel_approval_date).format(
                        "YYYY.MM.DD HH:mm:ss",
                      )
                    : ""}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label={
                    orderDetail.order_detail_status === "return_refusal"
                      ? "반품철회일"
                      : "반품완료일"
                  }
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  {orderDetail.order_detail_status === "return_refusal"
                    ? orderDetail.return_refusal_date
                      ? moment(orderDetail.return_refusal_date).format(
                          "YYYY.MM.DD HH:mm:ss",
                        )
                      : ""
                    : orderDetail.return_complete_date
                    ? moment(orderDetail.return_complete_date).format(
                        "YYYY.MM.DD HH:mm:ss",
                      )
                    : ""}
                </Form.Item>
              </Col>
            </Row>
            {orderDetail.return_refusal_date && (
              <Form.Item
                className="order-detail-form-border-box"
                label="반품철회사유"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 20 }}
              >
                {orderDetail.cancel_refusal_reason}
              </Form.Item>
            )}
            <Row align="middle" wrap={false}>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="반품 배송비"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ borderRight: 0 }}
                >
                  {orderDetail.return_responsibility === 0
                    ? (
                        orderDetail.return_delivery_price -
                        orderDetail.paid_total_delivery_price
                      )?.toLocaleString() + "원"
                    : ""}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="결제정보"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  {orderDetail.return_responsibility === 0
                    ? orderDetail.purchase_return_price
                      ? "선불"
                      : "환불금에서 차감"
                    : "판매자 부담"}
                </Form.Item>
              </Col>
            </Row>
            {orderDetail.etc_return_price ? (
              <>
                <Row align="middle" wrap={false}>
                  <Col span={12}>
                    <Form.Item
                      className="order-detail-form-border-box"
                      label="기타 반품비용"
                      labelAlign="left"
                      colon={false}
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      style={{ borderRight: 0 }}
                    >
                      {orderDetail.etc_return_price
                        ? orderDetail.etc_return_price.toLocaleString() + "원"
                        : ""}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      className="order-detail-form-border-box"
                      label="결제정보"
                      labelAlign="left"
                      colon={false}
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                    >
                      환불금에서 차감
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="기타 반품비용 청구사유"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 4 }}
                  wrapperCol={{ span: 20 }}
                >
                  <div className="order-detail-address-info">
                    {orderDetail.etc_return_price_reason}
                  </div>
                </Form.Item>
              </>
            ) : (
              <></>
            )}
            <Row align="middle" wrap={false}>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="수거 상태"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ borderRight: 0 }}
                >
                  {status.deliveryStatusChange(
                    orderDetail.return_delivery_status,
                  )}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="수거방법"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  {orderDetail.auto_shipping
                    ? "자동 택배사 접수"
                    : orderDetail.return_tracking_number
                    ? "택배 수거"
                    : "수거 정보 없음"}
                </Form.Item>
              </Col>
            </Row>
            <Row align="middle" wrap={false}>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="수거완료일"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ borderRight: 0 }}
                >
                  {orderDetail.return_collection_complete_date
                    ? moment(
                        orderDetail.return_collection_complete_date,
                      ).format("YYYY.MM.DD HH:mm:ss")
                    : ""}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="배송완료일"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  {orderDetail.return_delivery_complete_date
                    ? moment(orderDetail.return_delivery_complete_date).format(
                        "YYYY.MM.DD HH:mm:ss",
                      )
                    : ""}
                </Form.Item>
              </Col>
            </Row>
            <Row align="middle" wrap={false}>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="수거 택배사"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ borderRight: 0 }}
                >
                  {orderDetail.return_delivery_company
                    ? status.matchingDeliveryCompany[
                        orderDetail.return_delivery_company
                      ]
                    : ""}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="수거송장번호"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  {orderDetail.return_tracking_number ? (
                    <a
                      onClick={(e) => deliveryPopup(e, "return", orderDetail)}
                      href={`#`}
                    >
                      {orderDetail.return_tracking_number}
                    </a>
                  ) : (
                    ""
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              className="order-detail-form-border-box"
              label="수거지"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
              style={{ borderBottom: "solid 1px #ced4da" }}
            >
              {orderDetail.shipment_place}
            </Form.Item>
          </>
        )}
      {isPostalCodeModalOpen && (
        <Modal
          className="order-postal-code-modal"
          visible={isPostalCodeModalOpen}
          onCancel={() => setIsPostalCodeModalOpen(false)}
          footer={null}
        >
          <DaumPostcodeEmbed
            style={{
              height: "450px",
            }}
            submitMode={false}
            onComplete={handlePostCode}
          />
        </Modal>
      )}
    </>
  );
};

export default OrderDetailComponent;
